import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { PayloadAction } from '@reduxjs/toolkit';
import { UserId } from 'features/users/types';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';

export function* askUnmuteRemoteAudioSaga(action: PayloadAction<UserId>) {
  yield call(SignalingSocket.send, {
    event: 'askToUnmuteRemoteAudio',
    data: {
      id: action.payload,
    },
  });

  yield call(notification, i18n.t('notifications:unmute_request_sent'));
}
